import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Flux from "../../flux/Flux";
import Translations from "../../utils/Translations";
import PerfectScrollbar from "perfect-scrollbar";
import ProfileFeedbackList from "./ProfileFeedbackList";

const ProfileFeedback = (props) => {

    const { albumId, editable: initialEditable, items: initialItems, userPictureUrl } = props;

    const [total, setTotal] 	  = useState(0);
    const [items, setItems] 	  = useState(initialItems);
    const [editable, setEditable] = useState(initialEditable);

    const bodyRef = useRef(null);
    const ps = useRef(null);

    useEffect(() => {
        const onCommentsChange = (id) => {
            if (albumId === id) {
                populate(id);
            }
        };

        const onScroll = () => {
            if (
                bodyRef.current &&
                bodyRef.current.clientHeight + bodyRef.current.scrollTop + 50 > bodyRef.current.scrollHeight &&
                total > items.length
            ) {
                Flux.Gallery.showMoreComments(albumId);
            }
        };

        Flux.Gallery.addCommentsChangeListener(onCommentsChange);
        Flux.Gallery.showMoreComments(albumId);
        populate(albumId);

        if (bodyRef.current) {
            ps.current = new PerfectScrollbar(bodyRef.current, { wheelPropagation: true });
            bodyRef.current.addEventListener("scroll", onScroll);
        }

        return () => {
            Flux.Gallery.removeCommentsChangeListener(onCommentsChange);
            if (bodyRef.current) {
                bodyRef.current.removeEventListener("scroll", onScroll);
            }
        };
    }, [albumId]);

    useEffect(() => {
        setEditable(initialEditable);
    }, [initialEditable]);

    const populate = (id) => {
        const data = Flux.Gallery.getCommentsData(id);
        if (data) {
            setTotal(data.commentsTotal);
            setItems(data.comments);
            setEditable(data.isGuestAllowedToCommentAlbum);
            if (ps.current && bodyRef.current) {
                ps.current.update();
            }
        }
    };

    return (
        <div>
            <div className="context-box--actor-profile">
                <p className="context-box__subtitle -light h-no-margin">
                    {Translations.get("Feedbacks")} &nbsp;
                    <span className="h-color-highlight-dark">{total}</span>
                </p>
            </div>
            <div>
				<ProfileFeedbackList
                    albumId			   = {albumId}
                    editable		   = {editable}
                    userPictureUrl	   = {userPictureUrl}
                    total			   = {total}
                    items			   = {items}
                    updateBodyRef	   = {(ref) => (bodyRef.current = ref)}
                    showLoadMoreButton = {true}
                />
            </div>
        </div>
    );
};

ProfileFeedback.propTypes = {
	albumId:        PropTypes.number,
	editable:       PropTypes.bool,
	items:          PropTypes.array,
	userPictureUrl: PropTypes.string,
};

ProfileFeedback.defaultProps = {
	albumId:        0,
	editable:       true,
	items:          [],
	userPictureUrl: '',
};

export default ProfileFeedback;
